export const AUTH_SET_PROFILE = 'AUTH_SET_PROFILE' as const;
export const AUTH_UPDATE_AVATAR = 'AUTH_UPDATE_AVATAR' as const;
export const AUTH_UPDATE_AVATAR_URL = 'AUTH_UPDATE_AVATAR_URL' as const;
export const AUTH_UPDATE_EMAIL = 'AUTH_UPDATE_EMAIL' as const;
export const AUTH_UPDATE_NAME = 'AUTH_UPDATE_NAME' as const;
export const AUTH_UPDATE_PASSWORD = 'AUTH_UPDATE_PASSWORD' as const;
export const AUTH_REQUEST_PROFILE = 'AUTH_REQUEST_PROFILE' as const;
export const AUTH_FAILURE_REQUEST = 'AUTH_FAILURE_REQUEST' as const;
export const AUTH_FAILURE_UPDATE = 'AUTH_FAILURE_UPDATE' as const;
export const AUTH_UPDATE_PROFILE = 'AUTH_UPDATE_PROFILE' as const;
export const AUTH_LOGOUT = 'AUTH_LOGOUT' as const;
export const AUTH_RESET_MESSAGE = 'AUTH_RESET_MESSAGE' as const;

export const SET_SESSION_TIMER = 'SET_SESSION_TIMER' as const;
export const UPDATE_SESSION_TIMER = 'UPDATE_SESSION_TIMER' as const;
export const REMOVE_SESSION_TIMER = 'REMOVE_SESSION_TIMER' as const;

export const AUTH_GOVT_ID = 'AUTH_GOVT_ID' as const;

